import { twMerge } from "tailwind-merge";
import { SubTierView } from "./SubTierView";
import { TierImage } from "./TierImage";
import { getSubTierDisplayStatus } from "../utils/tierProgressUtils";

export function TierProgressCard({ isCurrentTier, tier, currentTier, currentSubTier, index }: { isCurrentTier: boolean, tier: any, currentTier?: number, currentSubTier?: number, index: number }) {
    return (
        <div className={twMerge("p-4 flex w-[350px] relative min-h-[calc(100vh-300px)] rounded-[10px] min-w-[350px] flex-col shadow-[0_1px_2px_-1px_rgba(0,0,0,0.10),_0_1px_3px_0_rgba(0,0,0,0.10)] bg-white", isCurrentTier ? "bg-background2" : "")}>
            <div className="flex flex-col gap-5">
                {tier.image_url && <TierImage imageUrl={tier.image_url} alt={tier.name} className="self-start" />}
                <div className="flex flex-col gap-1">
                    <div className="text-black text-lg font-semibold">{tier.name}</div>
                    <div className="text-sm text-black">You're getting oriented and building your practice habit.</div>
                </div>
                <div className="flex flex-col gap-7">
                    {(tier.sub_tiers ?? []).map((subTier: any) => (
                        <SubTierView
                            key={subTier.sub_tier}
                            tierName={tier.name}
                            subTierInfo={subTier}
                            status={getSubTierDisplayStatus(
                                tier.tier,
                                subTier.sub_tier,
                                currentTier,
                                currentSubTier,
                                subTier.is_completed,
                            )}
                        />
                    ))}
                </div>
            </div>
            {isCurrentTier && <div className="bg-primary5 absolute top-0 right-0 text-white text-sm leading-[18px] px-2.5 py-[5px] rounded-bl-[10px] rounded-tr-[10px]">
                Your current tier
            </div>}
        </div>
    )
}